"use client";

import React, { FC, MouseEvent } from "react";
import { useRouter } from "next/navigation";
import { useStyles } from "./styles";
import { applyFirstEditionDefaults } from "utils/cta";

import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import BlockIcon from "@mui/icons-material/Block";

export interface SubscriptionModalProps {
  onClose: () => void;
  onUpgrade: () => void;
  versionIdentifier?: string;
  ctaContent?: {
    modalTitle?: string;
    modalSubtitle?: string;
    feature1?: string;
    feature2?: string;
    feature3?: string;
    feature4?: string;
  };
}

const SubscriptionModal: FC<SubscriptionModalProps> = ({
  onClose,
  onUpgrade,
  versionIdentifier,
  ctaContent,
}) => {
  const { classes } = useStyles();
  const router = useRouter();

  const handleCancel = () => {
    onClose();
  };

  const handleUpgrade = () => {
    onUpgrade();
    router.push("/subscribe");
  };

  const defaults = {
    modalTitle: "Exclusive Content Unlocked",
    modalSubtitle: "Upgrade now to see premium images and advanced features.",
    feature1: "Unlimited Gallery Access",
    feature2: "Ultra HD Quality",
    feature3: "Secure & Private",
    feature4: "Ad-free experience",
  };

  const content = applyFirstEditionDefaults(
    versionIdentifier,
    "B",
    defaults,
    ctaContent
  );

  const features = [
    {
      icon: <PhotoLibraryIcon fontSize="small" />,
      text: content.feature1,
    },
    {
      icon: <CloudDownloadIcon fontSize="small" />,
      text: content.feature2,
    },
    {
      icon: <SupportAgentIcon fontSize="small" />,
      text: content.feature3,
    },
    {
      icon: <BlockIcon fontSize="small" />,
      text: content.feature4,
    },
  ];

  return (
    <div className={classes.modalOverlay} onClick={handleCancel}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>
            {content.modalTitle}
            <span className={classes.premiumBadge}>PREMIUM</span>
          </h2>
        </div>
        <div className={classes.modalBody}>
          <p>{content.modalSubtitle}</p>
          <ul className={classes.featureList}>
            {features.map((feature, idx) => (
              <li key={idx} className={classes.featureItem}>
                <span className={classes.featureIcon}>{feature.icon}</span>
                <span className={classes.featureText}>{feature.text}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className={classes.modalFooter}>
          <button
            className={`${classes.btn} ${classes.btnCancel}`}
            onClick={handleCancel}
          >
            CANCEL
          </button>
          <button
            className={`${classes.btn} ${classes.btnUpgrade}`}
            onClick={handleUpgrade}
          >
            UPGRADE NOW
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
